import { render, staticRenderFns } from "./addBrandMall.vue?vue&type=template&id=a0025384&scoped=true"
import script from "./addBrandMall.vue?vue&type=script&lang=js"
export * from "./addBrandMall.vue?vue&type=script&lang=js"
import style0 from "./addBrandMall.vue?vue&type=style&index=0&id=a0025384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0025384",
  null
  
)

export default component.exports